import { SimpleDateSelectType } from 'src/admin-entity/enum/search/simple-date-select-type.enum';
import { Category } from 'src/admin-entity/interface/category/category.interface';
import { ProductOld } from 'src/admin-entity/interface/product/product-old.interface';
import { SaleStatus } from 'src/admin-entity/enum/product/product-sale-status.enums';

export interface ProductSearchInitType {
    productType: number;
    productName: string;
    keyword: string;
    distributorName: string;
    category: { id: number; name: string };
    saleType: string;
    saleStatus: string[];
    searchResult: ProductOld[];
    isVideo: string;
    searchResultPage: {
        count: number;
    };
    page: number;
    take: number;
    selectedProducts: ProductOld[];
    startDate: string;
    endDate: string;
    selectedStartDateType: SimpleDateSelectType;
    startUpdateDate: string;
    endUpdateDate: string;
    selectedUpdateDateType: SimpleDateSelectType;
    filter: 'lastest' | 'priceOrderAsc' | 'priceOrderDesc' | 'updateDesc';
    taxStatus: 'tax-all' | 'taxable' | 'excempt' | 'small';
    categoryList: Category[];
    isCategoryFetchEnd: boolean;
    useGift: string;
    shipmentDateOptionType: string;
    isSpecialSale: string;
    productOptionName: string;
}

export const initialState: ProductSearchInitType = {
    productType: 0,
    productName: '',
    keyword: '',
    distributorName: '',
    category: { id: 0, name: '' },
    saleType: 'all',
    saleStatus: [SaleStatus.StockIn, SaleStatus.TempOut],
    searchResult: [],
    isVideo: 'all-video',
    searchResultPage: {
        count: 0,
    },
    page: 0,
    take: 10,
    selectedProducts: [],
    filter: 'lastest',
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)).toString(),
    endDate: new Date().toString(),
    selectedStartDateType: 'allDate',
    startUpdateDate: new Date(new Date().setDate(new Date().getDate() - 7)).toString(),
    endUpdateDate: new Date().toString(),
    selectedUpdateDateType: 'allDate',
    taxStatus: 'tax-all',
    categoryList: [],
    isCategoryFetchEnd: false,
    useGift: 'gift-all',
    shipmentDateOptionType: 'all',
    isSpecialSale: 'all',
    productOptionName: '',
};
